import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import MarketingSales from "@/pages/MarketingSales";

export const Route = createFileRoute("/by/octopus")({
  head: () => routeHead('AGAPE Octopus — Рухавік продажаў B2B', META_DESCRIPTIONS.octopus.by, '/by/octopus'),
  component: MarketingSales,
});
